
<ng-container>
  <div class="cp-styles">

    <div class="configure-product-heading font-size-17">Select Product</div>
      <div class="login-forms col-lg-12">
        <div class="form-group col-lg-12 pl-0 float-left mb-3 p-res-0 mt-3">
          <form [formGroup]="variantForm">
            <ng-select class="mb-1"  [items]="variantOptionsDropdownData" [placeholder]="'Select Value'" formControlName="variant"
              [searchable]="false" [clearable]="false" bindLabel="name" bindValue="value" (change)='handleVariantProductChange($event)'>
            </ng-select>
          </form>
        </div>
      </div>

  </div>
</ng-container>
  <!-- <ng-template [cxOutlet]="outlets.PRICE" [cxOutletContext]="{ product: product }">
    <table>
      <tr>
        <td>{{ 'productList.label.brand' | cxTranslate }}:</td>
        <td class="font-text-600 font-sm-size">{{ product.brandName }}</td>
      </tr>
      <tr>
        <td>{{ 'productList.label.material' | cxTranslate }}:</td>
        <td class="font-text-600 font-sm-size">{{ product.code }}</td>
      </tr>
      @if ((product?.hasPricing)) {
        <tr>
          <td>{{ 'productList.label.listPrice' | cxTranslate }}:</td>
          <td class="font-text-600 font-sm-size">{{ (product?.callForPricing | lowercase) === 'yes' ? product?.pricingText : product?.knbrPrice?.formatedListPrice }}</td>
        </tr>
      }
      @if ((product?.hasPricing)) {
        <tr>
          <td>{{ 'productList.label.netPrice' | cxTranslate }}:</td>
          <td class="font-text-600 font-sm-size">{{  (product?.callForPricing | lowercase) === 'yes' ? product?.pricingText : product?.knbrPrice?.formatedNetPrice }}</td>
        </tr>
      }
    </table>
  </ng-template> -->




  <!-- <div class="row mb-4 pt-1 pl-2">
    <div class="col-md-12 attachement" *ngIf="shouldProductandTechnicalDocumentationDisplay()">
      <u (click)="navigateTo('panel2')" href="">View Product and Technical Documentation &nbsp;<i
          class="fa fa-angle-right pt-1"></i></u>
    </div>
  </div> -->
